import assignmentsAction from 'modules/assignments/assignments.action';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from 'store';
import { TOptionsQuery } from 'types/common';
import { TAddTrainingBody } from 'types/assignments';
import templateAction from 'modules/template/template.action';
import AssignmentsAdm from './AssignmentsAdm';

const AssignmentsAdmContainer = () => {
  const dispatch = useDispatch();
  const assignmentsState = useSelector((state: AppState) => state.pages.assignments);
  const uiState = useSelector((state: AppState) => state.pages.ui);
  const { currentGroup } = useSelector((state: AppState) => state.pages.groupClass);

  const getTrainings = (params: TOptionsQuery<TAddTrainingBody>) => {
    dispatch(assignmentsAction.getTrainings({ ...params }));
  };

  const deleteTraining = (data: { trainingId: string; groupId: number }) => {
    dispatch(assignmentsAction.deleteTraining(data));
  };
  const resetStateTemplate = () => dispatch(templateAction.clearTemplate());

  return (
    <AssignmentsAdm
      assignmentsState={assignmentsState}
      uiState={uiState}
      getTrainings={getTrainings}
      deleteTraining={deleteTraining}
      resetStateTemplate={resetStateTemplate}
      currentGroup={currentGroup}
    />
  );
};

export default AssignmentsAdmContainer;
